import { useWizardEmit } from '@mwkt/react-magic-frame';
import { MagicFrameInnerEvent } from '../constants';

const useWizardEmitNavigateEvent = (skip?: boolean) => {
  return useWizardEmit<string>({ event: MagicFrameInnerEvent.Navigate, skip });
};

export default useWizardEmitNavigateEvent;
